import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatsisIfrs = () => {
  const urlConfig = {
    name: "Ifrs.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/IFRSS1&S2.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="IFRS"
            title={"IFRS Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ mb: 2 }}>
          <Typography
            component="h4"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 800,
              fontSize: "24px",
              lineHeight: "32px",
              color: "#2E7D32",
              mb: 2,
            }}
          >
            What are IFRS S1 & S2? – Brief Introduction
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              color: "#4F4F4F",
              mb: 2,
            }}
          >
            <strong>
              IFRS S1 (General Requirements for Disclosure of
              Sustainability-related Financial Information)
            </strong>{" "}
            and <strong>IFRS S2 (Climate-related Disclosures)</strong> are
            global sustainability disclosure standards issued by the{" "}
            <strong>International Sustainability Standards Board (ISSB)</strong>{" "}
            under the <strong>IFRS Foundation</strong>.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              color: "#4F4F4F",
              mb: 2,
            }}
          >
            <strong>IFRS S1</strong> provides a comprehensive framework for
            organizations to disclose material sustainability-related risks and
            opportunities that could affect enterprise value, ensuring
            consistent, comparable, and reliable sustainability-related
            financial reporting across industries and markets.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              color: "#4F4F4F",
              mb: 2,
            }}
          >
            <strong>IFRS S2</strong> builds specifically on the{" "}
            <strong>
              TCFD (Task Force on Climate-related Financial Disclosures)
            </strong>{" "}
            framework, setting out detailed disclosure requirements for
            climate-related risks and opportunities, including governance,
            strategy, risk management, metrics, and targets, along with scenario
            analysis and Scope 1, 2, and 3 GHG emissions.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              color: "#4F4F4F",
            }}
          >
            Together, <strong>IFRS S1 and S2</strong> aim to provide investors
            and stakeholders with high-quality, decision-useful sustainability
            and climate-related information that is integrated with financial
            reporting, advancing global alignment and improving market
            transparency.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <DownloadZipButton config={urlConfig} title="IFRS S1, S2 document" />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatsisIfrs;
